module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1028.c014e5b8.png";